import { render, staticRenderFns } from "./KohlerInfinityUpgradeButton.vue?vue&type=template&id=88f8078e&scoped=true&"
import script from "./KohlerInfinityUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./KohlerInfinityUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f8078e",
  null
  
)

export default component.exports